import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Navigate } from 'react-router-dom';
import { RootState } from '../../../data/reducers';
import { AppDispatch } from '../../../data/storeConfig';
import * as authActions from '../../../data/reducers/auth.reducer';

type ProtectedRouteProps = {
  children: React.ReactElement;
};

export const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { storeSlug } = useParams<any>();
  const { storeInfo } = useSelector((state: RootState) => state.storeReducer);
  const dispatch = useDispatch<AppDispatch>();
  const { isLoggedIn } = useSelector((state: RootState) => state.authReducer);

  useEffect(() => {
    dispatch(authActions.verifyLogin({ storeSlug: storeSlug ?? 'invalid-store-slug' }));
  }, []);

  if (!isLoggedIn) {
    return <Navigate to={`/${storeSlug}/login?redirectTo=${location.pathname}`} replace />;
  }
  return props.children;
};
